import { observer } from 'mobx-react'
import React from 'react'
import StatsVM from './StatsVM'
import { NavLink, Redirect, Route } from 'react-router-dom'
import Activity from './Activity'
import Reserve from './Reserve'
import Treasury from './Treasury'
import StatsChart from './Reserve/StatsChart'
import { chainConfigs, routes, supportedChains } from 'bzx-common/src/config/appConfig'
import { Button, Icon } from 'bzx-common/src/ui-framework'
import { apiNetworkNames } from 'app-lib/apis/bzxApi'

/* This component shows the stats for all reserves and treasury based on navigation */
export const Stats = ({ vm }: { vm: StatsVM }) => (
  <main className="margin-bottom-4">
    <div className="stats__nav flex-between">
      <nav className="txt-center btn--sticked-horizontal margin-mobile-bottom-2 margin-bottom-3">
        <NavLink to="/stats/reserve" className="btn btn--tab-blue">
          Reserve
        </NavLink>
        <NavLink
          to="/stats/treasury"
          className="btn btn--tab-blue"
          onClick={vm.statsStore.treasuryBalances.fetch}>
          Treasury
        </NavLink>
        <NavLink to="/stats/activity" className="btn btn--tab-blue">
          Activity
        </NavLink>
      </nav>

      {vm.rootStore.route !== routes.treasury && (
        <div className="btn--sticked-horizontal margin-mobile-bottom-2 margin-bottom-3">
          {supportedChains.map((chainId) => {
            return (
              <Button
                key={chainId}
                variant="tab-blue"
                onClick={vm.updateChain}
                onClickEmit="value"
                name="selectedChain"
                value={chainId}
                size="narrow"
                title={apiNetworkNames[chainId].toUpperCase()}
                active={chainId === vm.selectedChain}>
                <Icon
                  name={chainConfigs[chainId].icon.name}
                  color={chainConfigs[chainId].icon.color}
                  size={24}
                />
              </Button>
            )
          })}
        </div>
      )}
    </div>

    <div
      className={`panel--simple overflow-hidden padded-bottom-2 pos-rel stats-chart margin-bottom-2${
        vm.rootStore.route !== routes.reserve ? ' hidden' : ''
      }`}>
      <StatsChart vm={vm} />
    </div>
    <Route exact path={routes.reserve} render={() => <Reserve vm={vm} />}></Route>
    <Route exact path={routes.activity} render={() => <Activity vm={vm} />}></Route>
    <Route
      exact
      path={routes.treasury}
      render={() => <Treasury statsStore={vm.statsStore} />}></Route>
    <Route exact path={routes.stats} render={() => <Redirect to="/stats/reserve" />} />
  </main>
)

export default observer(Stats)
